<template>
  <div class="conversation-item" :class="[activeClass]" @click="loadMessages">
    <div class="conversation-item__bubble">
      <div class="conversation-item__avatar">
        <user-profile :size="43" :name="clientName" :picture="profileUrl">
          <circle-timer :last-message="lastMessage" />
          <channel-badge class="conversation-item__icon" :type="channelType" />
        </user-profile>
      </div>
      <div class="conversation-item__content">
        <span class="conversation-item__title">{{ clientName }}</span>
        <span class="conversation-item__subtitle">{{ timestamp }}</span>
        <span class="conversation-item__preview">
          <message-preview :client-id="client.id" :message="lastMessage" />
        </span>
        <div class="conversation-item__badge" v-if="hasUnreadMessages">
          {{ unreadMessagesLabel }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import MessagePreview from '@/components/MessagePreview.vue';
import UserProfile from '@/components/UserProfile.vue';
import CircleTimer from '@/components/CircleTimer.vue';
import ChannelBadge from '@/components/ChannelBadge.vue';

export default {
  components: {
    UserProfile,
    MessagePreview,
    CircleTimer,
    ChannelBadge,
  },
  props: {
    conversation: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...mapState({
      activeClientId: (state) => state.activeClientId,
    }),
    client() {
      return this.conversation.client;
    },
    channel() {
      return this.conversation.conversation.channel;
    },
    channelType() {
      return this.channel.channelType.key ?? '';
    },
    isActive() {
      return this.client.id === this.activeClientId;
    },
    activeClass() {
      return {
        active: this.isActive,
      };
    },
    clientName() {
      return this.client.fullName || this.client.name || this.client.username || '';
    },
    profileUrl() {
      return this.client.profilePic ?? '';
    },
    messages() {
      return this.conversation.messages;
    },
    lastMessage() {
      if (this.messages.length > 0) {
        return this.messages[this.messages.length - 1];
      }

      return null;
    },
    fromClient() {
      return this.messages.filter((m) => m.typeUser === 'Client');
    },
    unreadMessages() {
      return this.fromClient.filter((m) => m.readAt === null);
    },
    unreadMessagesTotal() {
      return this.unreadMessages.length;
    },
    unreadMessagesLabel() {
      return this.unreadMessagesTotal > 99 ? '+99' : this.unreadMessagesTotal;
    },
    hasUnreadMessages() {
      return this.unreadMessagesTotal > 0;
    },
    timestamp() {
      if (this.lastMessage && this.lastMessage.createdAt) {
        return this.globalFormatRelativeDateTime(this.lastMessage.createdAt);
      }

      return '';
    },
  },
  methods: {
    loadMessages() {
      this.$emit('clicked');
    },
  },
};
</script>
